import { Box, Button, IconButton, Stack, Typography } from "@mui/material"
import { RightDrawer } from "lib/@components/drawer/right-drawer"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { Sortable } from "lib/@components/Sortable"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import Iconify from "minimals-template/components/Iconify"
import { VariantPanelItem } from "./variant-panel-item"

export function VariantPanel({
    open,
    onClose,
    variants,
    selectedVariantId,
    onSelect,
    onAdd,
    onEdit,
    onRemove,
    onRecalculate,
    onReorder,
    onPromote,
}) {
    const canRemove = variants.length > 1
    const canReorder = typeof onReorder === "function"

    return (
        <RightDrawer open={open} setOpen={handleSetOpen} onClose={onClose}>
            <Stack data-cy="variant-panel" spacing={2} sx={{ height: "100%" }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Typography variant="h6">Variants</Typography>
                        <Typography variant="caption" color="text.secondary">
                            {variants.length} total
                        </Typography>
                    </Stack>
                    <IconButton aria-label="Close" size="small" onClick={onClose} data-cy="variant-panel-close">
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>

                <If value={onAdd}>
                    <Button
                        data-cy="variant-panel-add-btn"
                        variant="contained"
                        startIcon={<Iconify icon="mdi:plus" />}
                        onClick={handleAdd}
                    >
                        Add Variant
                    </Button>
                </If>

                <If value={variants.length === 0}>
                    <Box sx={{ py: 4, textAlign: "center" }}>
                        <Typography variant="body2" color="text.secondary">
                            No variants yet.
                        </Typography>
                    </Box>
                </If>

                <Stack spacing={1} sx={{ flex: 1, overflow: "auto" }}>
                    <Bound
                        selectedVariantId={selectedVariantId}
                        onSelectVariant={handleSelect}
                        onEditVariant={onEdit}
                        onRemoveVariant={onRemove}
                        onRecalculateVariant={onRecalculate}
                        onPromoteVariant={onPromote}
                        canRemoveVariant={canRemove}
                    >
                        <If value={canReorder}>
                            <Sortable items={variants} id="id" onOrdered={onReorder}>
                                <Repeat list={variants} item={<VariantPanelItem />} />
                            </Sortable>
                            <Else>
                                <Repeat list={variants} item={<VariantPanelItem />} />
                            </Else>
                        </If>
                    </Bound>
                </Stack>
            </Stack>
        </RightDrawer>
    )

    function handleSetOpen(value) {
        if (!value) onClose?.()
    }

    function handleSelect(variantId) {
        onSelect?.(variantId)
        onClose?.()
    }

    function handleAdd() {
        onClose?.()
        onAdd?.()
    }
}
